import { useQuery } from "@tanstack/react-query";
import type { PortalContentRow } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/portal-content — every row across all scopes/keys for the
// admin CMS. Active and inactive rows included; the partner-facing reads
// filter active downstream.
export function useAdminPortalContent() {
  return useQuery<PortalContentRow[], ApiClientError>({
    queryKey: queryKeys.portalContent.adminList(),
    queryFn: () => apiFetch<PortalContentRow[]>("/admin/portal-content"),
  });
}
